module.exports = __webpack_public_path__ + "catalog/items/table/table.png";